import React from 'react';
import { v4 as uuid } from 'uuid';
import { format } from 'date-fns';
import { Tag } from 'esa-ui-library';
import { PropertyType } from '../../../common';

// const getDeviceLabel = (value: number | string): string => {
// 	switch (Number(value)) {
// 		case 0:
// 			return 'Desktop only';
// 		case 1:
// 			return 'Mobile only';
// 		case 9:
// 			return 'All devices';
// 		default:
// 			return 'Unknown';
// 	}
// };

export const getRows = (campaigns: PropertyType[]): PropertyType[] => {
	// const getPartnerLabel = (skinId: number | string): string => {
	// 	const allOptions = partners.flatMap((group: any) => group.options || []);
	// 	const match = allOptions.find((opt: any) => Number(opt.skinId) === Number(skinId));
	// 	return match ? match.label : `#${skinId}`;
	// };

	return campaigns.map((c: PropertyType) => [
		<span key={uuid()}>{c.campaign_id}</span>,
		<span key={uuid()}>{c.name}</span>,
		<span key={uuid()}>{c.description}</span>,
		<span key={uuid()}>
			<Tag text={c.status || 'Disabled'} yellow={c.status === 'Upcoming'} lightGreen={c.status === 'Running'} />
		</span>,
		<span key={uuid()}>
			{c.start_date ? format(new Date(c.start_date), 'MMM dd, yyyy HH:mm') : ''} –{' '}
			{c.end_date ? format(new Date(c.end_date), 'MMM dd, yyyy HH:mm') : ''}
		</span>,
		<span key={uuid()}>{c.currency}</span>,
	]);
};
